import React from "react";

import { FormLabel } from "~/components/form/label";
import { FormFieldReset } from "~/components/form/reset";
import { Switch } from "~/components/switch";
import { useScope } from "~/tools/impulse";

import { Widget, WidgetBody, WidgetHeader } from "../../../_widget";
import { WidgetLegendModeField, WidgetLegendPositionField, WidgetLegendTableField } from "../../../widget-form/legend";
import { SettingsSectionFormField } from "../_field";
import { SettingsSectionGrid } from "../_section-grid";

import type { FormState } from "./form-state";

export interface SetupDashboardWidgetLegendProps {
	legend: FormState;
}

export const LegendSection: React.FC<SetupDashboardWidgetLegendProps> = ({ legend }) => {
	const scope = useScope();

	const enabled = legend.enabled.getInput(scope);
	const activeMode = legend.element.fields.mode.getActiveBranch(scope);

	return (
		<Widget>
			<WidgetHeader className="grid-cols-[auto_auto_1fr] uppercase" title="Legend">
				<Switch
					checked={enabled}
					name="dashboard-widget-legend-show"
					onCheckedChange={(show) => legend.enabled.setInput(show)}
				/>

				<FormFieldReset className="ml-auto" state={legend} />
			</WidgetHeader>

			<WidgetBody card>
				<SettingsSectionGrid className="grid-cols-[auto_1fr]">
					<SettingsSectionFormField layout="horizontal" state={legend.element.fields.position}>
						<FormLabel>Position</FormLabel>
						<WidgetLegendPositionField
							disabled={!enabled}
							name="dashboard-widget-legend-position"
							position={legend.element.fields.position}
						/>
					</SettingsSectionFormField>

					<SettingsSectionFormField layout="horizontal" state={legend.element.fields.mode.active}>
						<FormLabel>Mode</FormLabel>
						<WidgetLegendModeField
							disabled={!enabled}
							mode={legend.element.fields.mode.active}
							name="dashboard-widget-legend-mode"
						/>
					</SettingsSectionFormField>

					{activeMode?.kind === "table" && (
						<SettingsSectionFormField layout="horizontal" state={activeMode.value}>
							<FormLabel>Values</FormLabel>
							<WidgetLegendTableField disabled={!enabled} table={activeMode.value} />
						</SettingsSectionFormField>
					)}
				</SettingsSectionGrid>
			</WidgetBody>
		</Widget>
	);
};
